import {
  getIsSettingsUpdating,
  selectIsSavingWorkingProject,
  selectWorkingProjectRegistrationSettings,
} from '@/store/slices/project/selectors';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectMarketingEmailOptions } from '@/store/slices/settings/selectors';
import { MarketingOptInTypes } from '@/types/registration.types';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import Switch from '@ui/switch/switch';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import SettingsToggle from '../../controls/settings-toggle';

const MarketingEmailWidget = () => {
  const marketingEmailOptions = useAppSelector(selectMarketingEmailOptions);
  const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);
  const isSettingsUpdating = useAppSelector(getIsSettingsUpdating);
  const registrationSettings = useAppSelector(selectWorkingProjectRegistrationSettings);

  const dispatch = useAppDispatch();

  const isNoOptIn =
    marketingEmailOptions !== MarketingOptInTypes.singleOptIn &&
    marketingEmailOptions !== MarketingOptInTypes.doubleOptIn;
  const isDoubleOptIn = marketingEmailOptions === MarketingOptInTypes.doubleOptIn;

  const updateMarketingSettings = (newOption: MarketingOptInTypes, saveId: string) => {
    if (!registrationSettings) return;
    dispatch(
      saveWorkingProjectByFields({
        registration_settings: {
          ...registrationSettings,
          marketing_email_options: newOption,
        },
        saveId,
      })
    );
  };

  const handleMarketingEmailToggle = (_: string, on: boolean) => {
    updateMarketingSettings(
      on ? MarketingOptInTypes.singleOptIn : MarketingOptInTypes.noOptIn,
      'settings-marketing-opt-in'
    );
  };

  const handleDoubleOptInToggle = (_: string, on: boolean) => {
    updateMarketingSettings(
      on ? MarketingOptInTypes.doubleOptIn : MarketingOptInTypes.singleOptIn,
      'settings-marketing-double-opt-in'
    );
  };

  return (
    <SettingsToggle
      label="Marketing Emails Opt-in"
      value={!isNoOptIn}
      sKey="email"
      onToggle={handleMarketingEmailToggle}
      disabled={savingWorkingProject || isSettingsUpdating}
      gap="0"
    >
      <div
        style={{
          display: 'grid',
          gridTemplateRows: !isNoOptIn ? '1fr' : '0fr',
          transition: 'grid-template-rows 200ms',
        }}
      >
        <div style={{ overflow: 'hidden' }}>
          <Container
            className="flex gap-16 margin-t-16"
            borderRadius="8px"
            padding="6px 6px 6px 10px"
            background="var(--global-cont-2)"
            width="fit-content"
          >
            <Text className="S3" design="GlobalIcoText2">
              Double Opt-In
            </Text>
            <Switch
              on={isDoubleOptIn}
              onClick={handleDoubleOptInToggle}
              value={'double-opt-in'}
              disabled={savingWorkingProject || isSettingsUpdating}
            />
          </Container>
        </div>
      </div>
    </SettingsToggle>
  );
};

export default MarketingEmailWidget;
